(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gw-loyalty-page-faq"] && !Shopify.designMode) return;
  try {
    
  var items = document.querySelectorAll(".gw-lpl-faq__accordeon-button");

  function toggleAccordion() {
    var itemToggle = this.getAttribute('aria-expanded');
    
    // for (i = 0; i < items.length; i++) {
    //   items[i].setAttribute('aria-expanded', 'false');
    // }
    
    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    } else {
      this.setAttribute('aria-expanded', 'false');
    }
  }
  
  items.forEach(item => item.addEventListener('click', toggleAccordion));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-loyalty-page-hero"] && !Shopify.designMode) return;
  try {
    
  const placeholderBR = document.querySelector(".gw-widget-placeholder-BR");
  if (placeholderBR && (location.pathname.includes("rewards") || location.pathname.includes("loyalty"))){
    placeholderBR.style.display = "none";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-rewards-page-faq"] && !Shopify.designMode) return;
  try {
    
  var items = document.querySelectorAll(".gw-rpl-faq__button");

  function toggleAccordion() {
    var itemToggle = this.getAttribute('aria-expanded');
    
    // for (i = 0; i < items.length; i++) {
    //   items[i].setAttribute('aria-expanded', 'false');
    // }
    
    if (itemToggle == 'false') {
      this.setAttribute('aria-expanded', 'true');
    } else {
      this.setAttribute('aria-expanded', 'false');
    }
  }
  
  items.forEach(item => item.addEventListener('click', toggleAccordion));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gw-rewards-page-hero"] && !Shopify.designMode) return;
  try {
    
  const placeholderBR = document.querySelector(".gw-widget-placeholder-BR");
  if (placeholderBR && (location.pathname.includes("rewards") || location.pathname.includes("loyalty"))){
    placeholderBR.style.display = "none";
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
